import React, { Component } from "react";
import _ from "lodash";
import _chain from "lodash/chain";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { Parallax } from "react-skrollr";
import { multiLanguage } from "../../hoc";
import {
  BackgroundImage,
  Button,
  SliderWithLoading,
  Modal,
} from "../../components";
import { ComingSoon, GalleryImages } from "../../containers";
import { assetsPath } from "../../utils";
import { Player } from "video-react";

export default withRouter(
  @multiLanguage()
  class Gallery extends Component {
    static propTypes = {
      t: PropTypes.func.isRequired,
      isRenderTitle: PropTypes.bool,
    };
    static defaultProps = {
      isRenderTitle: false,
    };

    static getDerivedStateFromProps(props) {
      const hash = _.get(props, "location.hash");
      const hashContainVideo = hash.indexOf("#video") !== -1;
      const [, videoTitleKey] = hash.split("-");
      let targetVideoSource = props.video;
      if (videoTitleKey && props.videos && props.videos.length > 0) {
        const targetVideo = props.videos.find(
          (video) => video.titleKey === videoTitleKey
        );
        if (targetVideo) targetVideoSource = props.t(targetVideo.source);
      }
      // console.log("getDerivedStateFromProps", {
      //   showVideoModal: hashContainVideo && !_.isEmpty(targetVideoSource),
      //   hashContainVideo,
      //   targetVideoSource: !_.isEmpty(targetVideoSource),
      // });
      return {
        videoSource: targetVideoSource,
        showImagesModal: hash === "#images",
        // showVideoModal: hashContainVideo && targetVideoSource,
        showVideoModal: hashContainVideo,
        showTourModal: hash === "#tour",
      };
    }

    state = {
      selectedVirtualTourSubType: "",
      selectedVirtualTourType: "",
      showImagesModal: false,
      showVideoModal: false,
      showTourModal: false,
      showSubMenuVideo: false,
      videoSource: this.props.video,
    };

    componentDidUpdate(prevProps, prevState) {
      const { view360 } = this.props;
      console.log("+++++", { state: this.state, prevState });
      if (
        prevState.view360 !== view360 &&
        prevState.selectedVirtualTourType === ""
      ) {
        console.log("+++++++++++++++++++++++++++ 1", {
          prevState: prevState.selectedVirtualTourType,
          state: this.state.selectedVirtualTourType,
        });
        this.setState({
          selectedVirtualTourType: _.get(view360, [0, "id"]),
          selectedVirtualTourSubType: _.get(view360, [0, "list", 0, "id"]),
        });
      }
    }

    handleClickImages = () => {
      const { history } = this.props;
      history.push({ hash: "#images" });
    };
    handleClickVideo = () => {
      const { history, videos } = this.props;
      if (videos && videos.length > 0) {
        this.setState({
          showSubMenuVideo: !this.state.showSubMenuVideo,
        });
      } else {
        history.push({ hash: `#video` });
        this.setState({
          showVideoModal: true,
        });
      }
    };
    handleClickTour = () => {
      const { history } = this.props;
      history.push({ hash: "#tour" });
    };
    handleCloseImagesModal = () => {
      const { history } = this.props;
      history.push({ hash: "#gallery" });
    };
    handleCloseVideoModal = () => {
      const { history } = this.props;
      history.push({ hash: "#gallery" });
    };
    handleCloseTourModal = () => {
      const { history } = this.props;
      history.push({ hash: "#gallery" });
    };
    handleSelectVirtualTourType = (type) => {
      console.log("xxxxxx handleSelectVirtualTourType", type);
      this.setState({
        selectedVirtualTourType: type,
        selectedVirtualTourSubType: "",
      });
    };
    handleSelectVirtualTourSubType = (type, subType) => {
      this.setState({
        selectedVirtualTourType: type,
        selectedVirtualTourSubType: subType,
      });
    };
    handleClickViewVideo = (videoTitleKey) => {
      const { history } = this.props;
      console.log("handleClickViewVideo - videoSource", videoTitleKey);
      history.push({ hash: `#video-${videoTitleKey}` });
      this.setState({
        showVideoModal: true,
        showSubMenuVideo: false,
      });
    };
    renderVirtualTour = () => {
      const {
        selectedVirtualTourType,
        selectedVirtualTourSubType,
      } = this.state;
      const { image360, view360, page } = this.props;

      console.log("renderVirtualTour", { image360, view360 });
      if (image360) {
        return image360 ? (
          <iframe title="tour" src={image360} width="100%" height="100%" />
        ) : (
          <ComingSoon />
        );
      }
      if (!view360) {
        return image360 ? (
          <iframe title="tour" src={image360} width="100%" height="100%" />
        ) : (
          <ComingSoon />
        );
      }

      // let virtualTourView =
      //   _.find(view360, (view) => view.id === selectedVirtualTourType) ||
      //   _.head(view360);
      // let virtualTourElement = <div />;
      // if (
      //   virtualTourView &&
      //   _.get(virtualTourView, "src") &&
      //   _.get(virtualTourView, "type") !== "list"
      // ) {
      //   virtualTourElement = (
      //     <iframe
      //       title="tour"
      //       src={_.get(virtualTourView, "src")}
      //       width="100%"
      //       height="100%"
      //     />
      //   );
      // } else {
      //   virtualTourElement = (
      //     <ComingSoon
      //       fontColor={page === "laguna-beachside" ? "#fff" : "#000"}
      //       src={_.get(virtualTourView, "src")}
      //     />
      //   );
      // }

      let virtualTourView =
        _.find(view360, (view) => view.id === selectedVirtualTourType) ||
        _.head(view360);
      let virtualTourElement = <div />;
      if (
        virtualTourView &&
        virtualTourView.src
        // virtualTourView.type !== "list" &&
        // _.isEmpty(selectedVirtualTourType)
      ) {
        virtualTourElement = (
          <iframe
            title="tour"
            src={_.get(virtualTourView, "src")}
            width="100%"
            height="100%"
          />
        );
      } else {
        virtualTourElement = (
          <img
            className="banner-360"
            alt=""
            src={_.get(virtualTourView, "src")}
            width="100%"
            height="100%"
          />
        );
      }

      console.log("virtualTourElement", {
        virtualTourView,
        src: _.get(virtualTourView, "src"),
        type: _.get(virtualTourView, "type"),
        selectedVirtualTourType,
      });
      // console.log("renderVirtualTour - virtualTourElement", {
      //   view360,
      //   virtualTourElement,
      // });

      let buttonElements = _.map(view360, (view, i) => {
        console.log(".xxxxxxxxxxxxxxxxx", { view, id: view.id, src: view.src });
        // if (_.size(view.list) <= 0) {
        //   virtualTourElement = (
        //     <iframe
        //       title="tour"
        //       src={_.get(virtualTourView, "src")}
        //       width="100%"
        //       height="100%"
        //     />
        //   );
        // }
        if (view.list && _.size(view.list) > 0) {
          return (
            <div className="custom-dropdown direction-up">
              <Button
                className="main-button"
                defaultStyle={{
                  backgroundColor:
                    view.id === selectedVirtualTourType ||
                    (_.isEmpty(selectedVirtualTourType) && i === 0)
                      ? "#04a8a6"
                      : "#333",
                }}
              >
                {view.id.toUpperCase()}
              </Button>
              <div className="sub-list">
                {_.map(view.list, (subView, j) => {
                  console.log("xxxxxxxxxxxxxxxxx", { subView });
                  if (subView.id === selectedVirtualTourSubType) {
                    virtualTourElement = subView.src;
                  }
                  return (
                    <Button
                      defaultStyle={{
                        backgroundColor:
                          subView.id === selectedVirtualTourSubType
                            ? "#04a8a6"
                            : "rgba(51, 51, 51, 0.7)",
                      }}
                      onClick={() =>
                        this.handleSelectVirtualTourSubType(view.id, subView.id)
                      }
                    >
                      {subView.id.toUpperCase()}
                    </Button>
                  );
                })}
              </div>
            </div>
          );
        }

        return (
          <Button
            defaultStyle={{
              backgroundColor:
                view.id === selectedVirtualTourType ||
                (_.isEmpty(selectedVirtualTourType) && i === 0)
                  ? "#04a8a6"
                  : "#333",
            }}
            onClick={() => this.handleSelectVirtualTourType(view.id)}
          >
            {view.id.toUpperCase()}
          </Button>
        );
      });
      return (
        <div className="virtual-tour-container">
          {_.get(virtualTourView, "type") !== "hidden" && (
            <div className="type-selection">{buttonElements}</div>
          )}
          {virtualTourElement}
        </div>
      );
    };
    render() {
      console.log(">>>>>", this);
      const {
        videoSource,
        showImagesModal,
        showVideoModal,
        showTourModal,
        showSubMenuVideo,
      } = this.state;
      const { page, t, heroShot, videos, isRenderTitle } = this.props;
      let title = `Gallery-title-${page}`;
      if (page === "phuket-dusit-deluxe-pool-villa") {
        title = {
          en: "DUSIT LAGUNA RESORT VILLAS, PHUKET",
          cn: "普吉岛乐古浪都喜度假别墅酒店",
          ru: "DUSIT LAGUNA RESORT VILLAS, PHUKET",
        };
      }
      // if (page === "laguna-beachside") {
      //   title = {
      //     en: "DUSIT LAGUNA RESORT VILLAS, PHUKET",
      //     cn: "普吉岛乐古浪都喜度假别墅酒店",
      //     ru: "DUSIT LAGUNA RESORT VILLAS, PHUKET",
      //   };
      // }
      // _.lastIndexOf([1, 2, 1, 2], 2);
      // const users = [
      //   { user: "barney", age: 36 },
      //   { user: "fred", age: 40 },
      //   { user: "pebbles", age: 1 },
      // ];

      // const type = _chain(users)
      //   .sortBy("age")
      //   .map(function(o) {
      //     return o.user + " is " + o.age;
      //   })
      //   .head()
      //   .value();

      const type = _.last(_.split(t(videoSource), "."));
      // const type = _.last(_.split(videoSource, "."));
      // const type = _.last(_.split(_.get(videoSource, "en"), "."));
      console.log(
        "videoSource",
        // {
        //   showVideoModal,
        //   videoSource,
        //   type,
        // },
        // t(videoSource),
        heroShot
      );
      const hasMultipleVideo = videos && videos.length > 1;
      return (
        <div className="section-gallery">
          <div className="parallax-container">
            <Parallax
              data={{
                "data-0-start": "transform: translateY(0px);",
              }}
            >
              <div className="image-slider-block">
                <SliderWithLoading
                  items={heroShot}
                  des={_.get(heroShot, "title")}
                  duration={6000}
                  loadingHeight={7}
                  loadingColor="#04a8a6"
                  position="bottom"
                  isRenderTitle
                  t={t}
                />
              </div>
            </Parallax>
          </div>
          {isRenderTitle === false && (
            <div className="content-block">
              <div>
                <h1 dangerouslySetInnerHTML={{ __html: t(title) }} />
                <div className="button-actions">
                  <Button
                    type="primary"
                    hoverStyle={{ backgroundColor: "white", color: "#04a8a6" }}
                    defaultStyle={{ marginRight: "8px" }}
                    onClick={this.handleClickImages}
                  >
                    <img
                      src={`${assetsPath(
                        "phuket-laguna-village-residences"
                      )}/images/icon/icon-image.png`}
                      alt=""
                    />{" "}
                    {t("Images")}
                  </Button>
                  <Button
                    type="primary"
                    hoverStyle={{ backgroundColor: "white", color: "#04a8a6" }}
                    defaultStyle={{ marginRight: "8px", minWidth: "120px" }}
                    onClick={this.handleClickVideo}
                  >
                    <img
                      src={`${assetsPath(
                        "phuket-laguna-village-residences"
                      )}/images/icon/icon-vdo.png`}
                      alt=""
                    />{" "}
                    {t("Video")}
                    {hasMultipleVideo && (
                      <div
                        className={`button-submenu ${
                          showSubMenuVideo ? "show" : "hide"
                        }`}
                      >
                        <ul className="list">
                          {videos.map((_video) => (
                            <li
                              onClick={() =>
                                this.handleClickViewVideo(_video.titleKey)
                              }
                            >
                              {_.map(t(_.get(_video, "text", {})), (text) => (
                                <p>{text}</p>
                              ))}
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </Button>
                  <Button
                    type="primary"
                    hoverStyle={{ backgroundColor: "white", color: "#04a8a6" }}
                    defaultStyle={{ marginRight: "8px" }}
                    onClick={this.handleClickTour}
                  >
                    <img
                      src={`${assetsPath(
                        "phuket-laguna-village-residences"
                      )}/images/icon/icon-360.png`}
                      alt=""
                    />{" "}
                    {t("Tour")}
                  </Button>
                </div>
              </div>
            </div>
          )}
          {}
          {showImagesModal && (
            <Modal name="gallery-modal" onCancel={this.handleCloseImagesModal}>
              <GalleryImages {...this.props} />
            </Modal>
          )}
          {showVideoModal && (
            <Modal name="video-modal" onCancel={this.handleCloseVideoModal}>
              {type === "mp4" ? (
                <Player playsInline autoPlay mute src={t(videoSource)} />
              ) : (
                <ComingSoon
                  fontColor={page === "laguna-beachside" ? "#fff" : "#000"}
                  src={t(videoSource)}
                />
              )}
            </Modal>
          )}
          {showTourModal && (
            <Modal name="tour-modal" onCancel={this.handleCloseTourModal}>
              {this.renderVirtualTour()}
            </Modal>
          )}
        </div>
      );
    }
  }
);



// WEBPACK FOOTER //
// ./src/pages/common/Gallery.js